export const NAV_WIDTH_DEFAULT = '220px';
export const NAV_MOBILE_MAX_WIDTH = '308px';
